import React from "react";
import { useTheme } from "components/common/hooks/useTheme/useTheme";
import { CrossSellBase } from "./CrossSellBase";
import links from "lib/links";
import { Route } from "lib/routes";
import brexLogo from "public/images/launchpad/Brex.webp";
import { blackLogoStyle, CROSS_SELL_LOGO_IMAGE_CONTAINER_HEIGHT } from "./crossSellBase.css";
import Image from "next/image";
import { FeatureFlag, isPosthogFeatureFlagEnabled } from "lib/analytics/featureFlags";
import { AccountSubType, AccountType, AccountWithIntegrationFragment } from "graphql/types";

export const shouldCrossSellBrex = (
  accounts: Pick<AccountWithIntegrationFragment, "type" | "subType">[],
  accountsLoading: boolean
) => {
  if (isPosthogFeatureFlagEnabled(FeatureFlag.CrossSellBrexToAllCompanies)) {
    // to be used for testing/demo, shouldn't be used in production
    return true;
  }
  if (isPosthogFeatureFlagEnabled(FeatureFlag.CrossSellBrexToCompaniesWithoutCreditCard)) {
    const hasCreditCardAccount = accounts.some(
      (account) =>
        account.type === AccountType.Credit && account.subType === AccountSubType.CreditCard
    );
    return !accountsLoading && !hasCreditCardAccount;
  }
  return false;
};

export const CrossSellBrex = () => {
  const { mode } = useTheme();
  return (
    <CrossSellBase
      logo={
        <Image
          src={brexLogo}
          height={CROSS_SELL_LOGO_IMAGE_CONTAINER_HEIGHT}
          // todo: RED-1882, do this with semantic token or have black logo or svg
          // can't find a good black logo or svg right now and can't figure out how
          // to do this with semantic token
          // certainly a number of ways this could
          // be done differently (better)
          className={mode === "light" ? blackLogoStyle : undefined}
          alt="Brex logo"
        />
      }
      title="Set up a dedicated business card"
      description="Puzzle integrates with leading business credit cards and spend management solutions to effortlessly automate accounting."
      line1Actions={[
        {
          text: "Sign up",
          link: links.crossSell.brexSignup,
          external: true,
          buttonVariant: "primary",
        },
        {
          text: "Connect my credit card",
          link: Route.integrations,
          external: false,
          buttonVariant: "secondary",
        },
      ]}
      line2Actions={[
        {
          text: "See other offers",
          link: links.partnerRewards,
          external: true,
        },
      ]}
    />
  );
};
